// extracted by mini-css-extract-plugin
module.exports = {"timer":"Insurgency_timer__-Ib7H","insurgecnyTooltip":"Insurgency_insurgecnyTooltip__9vPcG"};